<template>
  <div>
    <div class="d-none d-md-block">
      <div v-on:click="goToList" class="position-relative d-flex cursor-pointer" :style="{
        'justify-content': getJustifyContent(),
        'align-items': getAlignItems(),
      }">
        <img width="100%" :src="pluginSettings.banner" alt="" />
        <div class="position-absolute pl-3">
          <h1>{{ pluginSettings.bannerTitle }}</h1>
          <h3>{{ pluginSettings.bannerText }}</h3>
        </div>
      </div>
    </div>
    <div class="d-md-none" v-on:click="goToList" >
      <img width="100%" :src="pluginSettings.mobileBanner" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
export default {
  name: "BannerSection",
  mounted() {
    this.scrollTo();
    Vue.setHeight();
  },
  computed: mapState({
    pluginSettings: (state) => state.config.pluginSettings,
  }),
  methods: {
    scrollTo() {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: 0,
        },
        "*"
      );
    },
    goToList() {
      // this.$router.push({ name: "list" });
      window.parent.postMessage(
        {
          func: "gotoConfiguratorUrl",
          message: true,
        },
        "*"
      );
    },
    getAlignItems() {
      if (this.pluginSettings.position === "left" || this.pluginSettings.position === "right")
        return "center";
      return "";
    },
    getJustifyContent() {
      if (this.pluginSettings.position === "left") return "left";
      if (this.pluginSettings.position === "right") return "right";
      else return "center";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  font-size: 14px;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
}

h3 {
  font-size: 10px;
}

@media only screen and (min-width: 768px) {
  h1 {
    font-size: 55px;
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }

  h3 {
    font-size: 30px;
  }
}
</style>
